 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		61: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		61: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","6":"component---src-pages-404-js","7":"component---src-pages-about-us-js","8":"component---src-pages-awards-js","9":"component---src-pages-baby-js","10":"component---src-pages-colored-stones-js","11":"component---src-pages-contact-us-js","12":"component---src-pages-designer-benchmark-js","13":"component---src-pages-designer-forevermark-js","14":"component---src-pages-designer-marco-bicego-js","15":"component---src-pages-designer-michele-js","16":"component---src-pages-designer-penny-preville-js","17":"component---src-pages-designer-robertocoin-js","18":"component---src-pages-designer-seiko-js","19":"component---src-pages-designer-tudor-js","20":"component---src-pages-diamond-calculator-js","21":"component---src-pages-diamond-education-js","22":"component---src-pages-engagement-js","23":"component---src-pages-estate-js","24":"component---src-pages-faq-js","25":"component---src-pages-fashion-js","26":"component---src-pages-financing-js","27":"component---src-pages-index-js","28":"component---src-pages-jewelry-repair-js","29":"component---src-pages-locations-js","30":"component---src-pages-our-diamond-js","31":"component---src-pages-our-history-js","32":"component---src-pages-our-team-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-products-anniversary-js","35":"component---src-pages-products-bracelets-js","36":"component---src-pages-products-colored-gemstones-js","37":"component---src-pages-products-earrings-js","38":"component---src-pages-products-engagement-js","39":"component---src-pages-products-estate-js","40":"component---src-pages-products-fashion-js","41":"component---src-pages-products-index-js","42":"component---src-pages-products-necklace-js","43":"component---src-pages-products-rings-js","44":"component---src-pages-products-specials-js","45":"component---src-pages-products-underwoods-designs-js","46":"component---src-pages-products-womans-bands-js","47":"component---src-pages-registry-js","48":"component---src-pages-returns-js","49":"component---src-pages-rolex-js","50":"component---src-pages-services-js","51":"component---src-pages-shipping-js","52":"component---src-pages-terms-of-service-js","53":"component---src-pages-thank-you-js","54":"component---src-pages-trading-selling-js","55":"component---src-pages-underwoods-designs-js","56":"component---src-pages-watch-repair-js","57":"component---src-pages-watches-js","58":"component---src-pages-wedding-anniversary-js","59":"component---src-templates-designer-template-js","60":"pages-manifest"}[chunkId]||chunkId) + "-" + {"0":"67e8056047a475736711","1":"8cf8f3d022d240ce37f8","2":"fb06951960cb084a4a15","3":"6dca18cd05b3fff7d351","4":"092b4e47d7e43a38733d","6":"4f7eeefee97c2efbf295","7":"cbe7f70de3f36dbc7603","8":"322c877015cbb9aab73e","9":"f61b9b1e7adf68f6bb5a","10":"bc4da7a1c3db4c4fd618","11":"94918d627cb3be78079b","12":"21739c9db99ba24e1644","13":"721ec6efab5f73199b48","14":"c1cbd14ad5cc14f97e31","15":"a781c2383af4a0a13c1e","16":"3e4e7c723f1aa9128298","17":"68974de03a666c1c6c26","18":"279be7ccd5fd12243302","19":"938f29bc4fd920698056","20":"f58bf4f938c697c750a0","21":"10c89258278e4d74a0ac","22":"bac0c9d87916204e4db7","23":"a34de41573543537005f","24":"8a037088fc98564bb353","25":"24f51fa87713e7471c6d","26":"398f557cc8812b3bbb3c","27":"3e23de5450e563cf533f","28":"7304a3b776221cf16af4","29":"3484aec1a464cf3e004f","30":"e009b106fbaade55d425","31":"b1703046e3af2037028e","32":"a07082558e8af7f526cb","33":"b0605d0a6b15226f7802","34":"a28b566d399503437605","35":"d58580fc6a39a4c7658f","36":"c75278068d93fc82abe9","37":"e8796896cbbe63c05986","38":"1421fa8c5bfcbbd99f3f","39":"5b6acb9049e4bab6d0cc","40":"1bb3d253217c77607213","41":"9620d2a5eb2229ca9d26","42":"772cb66ba811c76d98eb","43":"16864c53b4d3296d5298","44":"fb160489b5b9059eff92","45":"c3233eac5563f2e14c38","46":"53dcf527dfa70d8f123f","47":"7a07213f7a54710944ba","48":"575cbf8bb1e70fc5e2c8","49":"9a9e7b21bd39251e2d04","50":"77dff1c6cf131150dd43","51":"91ee021a696f6cb812ed","52":"8ba3bd7b2bef73929800","53":"932a1f97a81e80c4367c","54":"c0a940452d18b80c98e8","55":"c26a8da6f05d330fcbf1","56":"9d16f2ed4434a1f25d35","57":"20eba6d44a080d06ca6d","58":"81b67b5239901884424f","59":"779d3af804a830405935","60":"9ce2945585cb083c9276"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","6":"component---src-pages-404-js","7":"component---src-pages-about-us-js","8":"component---src-pages-awards-js","9":"component---src-pages-baby-js","10":"component---src-pages-colored-stones-js","11":"component---src-pages-contact-us-js","12":"component---src-pages-designer-benchmark-js","13":"component---src-pages-designer-forevermark-js","14":"component---src-pages-designer-marco-bicego-js","15":"component---src-pages-designer-michele-js","16":"component---src-pages-designer-penny-preville-js","17":"component---src-pages-designer-robertocoin-js","18":"component---src-pages-designer-seiko-js","19":"component---src-pages-designer-tudor-js","20":"component---src-pages-diamond-calculator-js","21":"component---src-pages-diamond-education-js","22":"component---src-pages-engagement-js","23":"component---src-pages-estate-js","24":"component---src-pages-faq-js","25":"component---src-pages-fashion-js","26":"component---src-pages-financing-js","27":"component---src-pages-index-js","28":"component---src-pages-jewelry-repair-js","29":"component---src-pages-locations-js","30":"component---src-pages-our-diamond-js","31":"component---src-pages-our-history-js","32":"component---src-pages-our-team-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-products-anniversary-js","35":"component---src-pages-products-bracelets-js","36":"component---src-pages-products-colored-gemstones-js","37":"component---src-pages-products-earrings-js","38":"component---src-pages-products-engagement-js","39":"component---src-pages-products-estate-js","40":"component---src-pages-products-fashion-js","41":"component---src-pages-products-index-js","42":"component---src-pages-products-necklace-js","43":"component---src-pages-products-rings-js","44":"component---src-pages-products-specials-js","45":"component---src-pages-products-underwoods-designs-js","46":"component---src-pages-products-womans-bands-js","47":"component---src-pages-registry-js","48":"component---src-pages-returns-js","49":"component---src-pages-rolex-js","50":"component---src-pages-services-js","51":"component---src-pages-shipping-js","52":"component---src-pages-terms-of-service-js","53":"component---src-pages-thank-you-js","54":"component---src-pages-trading-selling-js","55":"component---src-pages-underwoods-designs-js","56":"component---src-pages-watch-repair-js","57":"component---src-pages-watches-js","58":"component---src-pages-wedding-anniversary-js","59":"component---src-templates-designer-template-js","60":"pages-manifest"}[chunkId]||chunkId) + "." + {"0":"b91d682e88829f829f48","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
